import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Upload, message, Table, Alert, Typography, Checkbox } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import voucherApi from "../../../api/voucherApi";

const { Dragger } = Upload;
const { Text, Paragraph } = Typography;

function VoucherImport() {
    const navigate = useNavigate();
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [appOnly, setAppOnly] = useState(false);

    const handleUpload = async () => {
        if (!file) {
            message.error("Vui lòng chọn file CSV");
            return;
        }

        try {
            setLoading(true);
            const { data } = await voucherApi.importVouchers(file, appOnly);
            setResult(data.data);
            if (data.data.successCount > 0) {
                message.success(`Import thành công: ${data.data.successCount} voucher${data.data.errorCount > 0 ? `, ${data.data.errorCount} lỗi` : ""}`);
            } else {
                message.warning(`Import hoàn tất nhưng không có voucher nào thành công. Lỗi: ${data.data.errorCount}`);
            }
        } catch (error) {
            message.error(error?.response?.data?.message || "Import thất bại");
        } finally {
            setLoading(false);
        }
    };

    const uploadProps = {
        beforeUpload: (selectedFile) => {
            setFile(selectedFile);
            setResult(null);
            return false;
        },
        accept: ".csv",
        maxCount: 1,
    };

    return (
        <div className="p-6 max-w-4xl mx-auto">
            <div className="flex items-center justify-between mb-4">
                <h1 className="text-2xl font-bold mb-0">Import Voucher từ CSV</h1>
                <a href={voucherApi.getSampleCsvUrl()} download>
                    <Button icon={<DownloadOutlined />}>Tải file mẫu</Button>
                </a>
            </div>

            <Alert
                className="mb-4"
                type="info"
                showIcon
                message="Hướng dẫn"
                description={
                    <div>
                        <Paragraph className="mb-1">Các cột bắt buộc (theo thứ tự):</Paragraph>
                        <Text code>code, secret_code, value, redeem_cost, partner, title, description, image_url, target_url, start_at, end_at</Text>
                        <ul className="mt-2 mb-0 text-sm">
                            <li><b>partner</b>: SHOPEE, LAZADA, TIKTOK, OTHER</li>
                            <li><b>start_at / end_at</b>: <Text code>YYYY-MM-DD HH:mm</Text> hoặc <Text code>M/D/YYYY H:MM</Text></li>
                            <li><b>redeem_cost</b>: giá đổi (điểm). Để trống = bằng mệnh giá; nhập <Text code>0</Text> = <b>voucher 0đ</b></li>
                        </ul>
                        <Paragraph className="mt-2 mb-0 text-xs text-content-3">
                            File mẫu tải về có thể mở và chỉnh sửa bằng Excel/Google Sheets mà không bị lỗi tiếng Việt.
                        </Paragraph>
                    </div>
                }
            />

            <div className="mb-4">
                <Dragger {...uploadProps}>
                    <p className="ant-upload-text">Click hoặc kéo thả file CSV vào đây</p>
                    <p className="ant-upload-hint">Chỉ chấp nhận file .csv</p>
                </Dragger>
            </div>

            <div className="mb-3">
                <Checkbox checked={appOnly} onChange={(e) => setAppOnly(e.target.checked)}>
                    Chỉ đổi trên App (đánh dấu <b>toàn bộ</b> voucher trong file — web vẫn hiện, bấm → mời tải app)
                </Checkbox>
            </div>

            <div className="flex gap-2 mb-4">
                <Button type="primary" onClick={handleUpload} loading={loading} disabled={!file}>
                    Import
                </Button>
                <Button onClick={() => navigate("/voucher")}>Quay lại</Button>
            </div>

            {result && (
                <div>
                    <p>✅ Thành công: <b>{result.successCount}</b></p>
                    <p>❌ Lỗi: <b>{result.errorCount}</b></p>
                    {result.errors && result.errors.length > 0 && (
                        <Table
                            dataSource={result.errors.map((e, i) => ({ ...e, key: i }))}
                            columns={[
                                { title: "Dòng", dataIndex: ["row", "code"], key: "code", render: (_, r) => r.row?.code || "-" },
                                { title: "Lỗi", dataIndex: "error", key: "error" },
                            ]}
                            pagination={false}
                            size="small"
                        />
                    )}
                </div>
            )}
        </div>
    );
}

export default VoucherImport;

